<template>
  <div class="selectable-btn">
    <v-select
      v-model="status"
      :items="items"
      item-text="name"
      item-value="status"
      solo
      outlined
      dense
      class="button font-weight-bold"
    ></v-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { name: '編集モード', status: 'edit' },
        { name: 'コメントモード', status: 'comment' }
      ]
    }
  },
  computed: {
    status: {
      get () {
        return this.$store.state.PostEditor.toolBarStatus
      },
      set (value) {
        this.$store.commit('PostEditor/SET_TOOL_BAR_STATUS', value)
      }
    }
  }
}
</script>

<style scoped lang="sass">
.selectable-btn
  margin: -5px 0 0 40px
  width: 180px
</style>
